var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Component } from 'react';
import { MDCList } from '@material/list';
import classNames from 'classnames';
import { Link } from '@reach/router';
import './drawer.css';
var Drawer = /** @class */ (function (_super) {
    __extends(Drawer, _super);
    function Drawer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.ripples = [];
        _this.initDrawer = function (drawerEle) {
            if (!drawerEle)
                return;
            if (_this.props.type === 'dismissible' || _this.props.type === 'modal') {
                if (_this.props.init) {
                    _this.props.init(drawerEle);
                }
            }
        };
        _this.initList = function (mdcListEl) {
            if (mdcListEl) {
                if (_this.props.type === 'modal')
                    mdcListEl.addEventListener('click', function () {
                        if (_this.props.closeDrawer)
                            _this.props.closeDrawer();
                    });
                else if (_this.props.type !== 'dismissible') {
                    _this.list = MDCList.attachTo(mdcListEl);
                    if (_this.props.type === 'permanent') {
                        _this.list.wrapFocus = true;
                    }
                }
            }
        };
        return _this;
    }
    Drawer.prototype.componentWillUnmount = function () {
        this.ripples.forEach(function (ripple) { return ripple.destroy(); });
        if (this.list)
            this.list.destroy();
    };
    Drawer.prototype.render = function () {
        var _this = this;
        var _a = this.props, type = _a.type, _b = _a.groups, groups = _b === void 0 ? [] : _b, header = _a.header, className = _a.className;
        var classes = classNames({
            'mdc-drawer--modal': type === 'modal',
            'mdc-drawer--dismissible': type === 'dismissible'
        }, className);
        var activated = groups.findIndex(function (x) { return x === null || x === void 0 ? void 0 : x.selected; });
        return (React.createElement("aside", { className: "mdc-drawer " + classes, ref: this.initDrawer },
            header === true ? (React.createElement("div", { className: "mdc-drawer__header" },
                React.createElement("h3", { className: "mdc-drawer__title" }, "Title"),
                React.createElement("h6", { className: "mdc-drawer__subtitle" }, "subtext"))) : header ? (header()) : null,
            React.createElement("div", { className: "mdc-drawer__content" },
                React.createElement("nav", { className: "mdc-list", ref: this.initList }, groups.map(function (item, index) {
                    var _a;
                    if (item) {
                        var className_1 = activated === index
                            ? 'mdc-list-item mdc-list-item--activated'
                            : 'mdc-list-item';
                        return (React.createElement(NavLinkDecider, { root: item.root, to: (_a = item.href) !== null && _a !== void 0 ? _a : '#', key: index, className: classNames(item.className, className_1), onClick: function () {
                                if (item.action) {
                                    item.action();
                                }
                                if (_this.props.onNavClick) {
                                    _this.props.onNavClick(item);
                                }
                            } },
                            React.createElement("i", { className: "material-icons mdc-list-item__graphic", "aria-hidden": "true" }, item.icon),
                            item.value));
                    }
                    else {
                        return (React.createElement("hr", { className: "mdc-list-divider", key: index }));
                    }
                })))));
    };
    Drawer.displayName = 'ba-drawer';
    return Drawer;
}(Component));
export { Drawer };
var NavLinkDecider = function (props) {
    var root = props.root, passThrough = __rest(props, ["root"]);
    return root ? (React.createElement(ExactNavLink, __assign({}, passThrough))) : (React.createElement(PartialNavLink, __assign({}, passThrough)));
};
// this is only active when the location pathname is exactly
// the same as the href.
var isActive = function (className) { return function (props) {
    var classes = classNames({
        'mdc-list-item--activated': props.isCurrent
    }, className);
    return props.isCurrent ? { className: classes, tabIndex: 0 } : {};
}; };
var ExactNavLink = function (props) { return (React.createElement(Link, __assign({ getProps: isActive(props.className) }, props), props.children)); };
// this link will be active when itself or deeper routes
// are current
var isPartiallyActive = function (className) { return function (props) {
    var classes = classNames({
        'mdc-list-item--activated': props.isPartiallyCurrent
    }, className);
    return props.isPartiallyCurrent ? { className: classes, tabIndex: 0 } : {};
}; };
var PartialNavLink = function (props) { return (React.createElement(Link, __assign({ getProps: isPartiallyActive(props.className) }, props), props.children)); };
//# sourceMappingURL=Drawer.js.map